// extracted by mini-css-extract-plugin
module.exports = {"container":"Domanda_container__3xkVh","error":"Domanda_error__1Ls34"};